var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEqualsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.296,
    height: 20.025,
    viewBox: "0 0 14.296 20.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3d4463;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2228.852 -4135.975)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2228.852,4135.975h4.751V4156h-4.751Zm9.546,0h4.75V4156h-4.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualsVertical);
export default __webpack_public_path__ + "static/media/equals-vertical.4e27430bc2e126c49b1e9bb83c28affb.svg";
export { ForwardRef as ReactComponent };